import { z } from 'zod';

const zId = z.coerce.number();

/**
 * A base set of store attributes. This is a small subset to accommodate when
 * stores are serialized as part of an associated model (eg. kiosk.stores).
 */
const zBaseStore = z.object({
  address: z.string(),
  city: z.string().nullable(),
  custom_navigation_color: z.string().nullable(),
  custom_theme_color: z.string().nullable(),
  country_code: z.string().nullish(),
  delivery: z.boolean().nullish(),
  description: z.string().nullable(),
  id: zId,
  kiosk_allow_auth: z.boolean(),
  kiosk_anonymous_checkout: z.enum(['allowed', 'required', 'none']),
  latitude: z.number(),
  longitude: z.number(),
  name: z.string(),
  photo: z.string().nullish(),
  pickup: z.boolean().nullish(),
  recreational: z.boolean(),
  state: z.string().nullable(),
  time_zone_identifier: z.enum([
    'Alaska',
    'Arizona',
    'Central Time (US & Canada)',
    'Eastern Time (US & Canada)',
    'Hawaii',
    'Indiana (East)',
    'Mountain Time (US & Canada)',
    'Pacific Time (US & Canada)',
    'Puerto Rico',
    'America/Juneau',
    'America/Phoenix',
    'America/Chicago',
    'America/New_York',
    'Pacific/Honolulu',
    'America/Indiana/Indianapolis',
    'America/Denver',
    'America/Los_Angeles',
    'America/Puerto_Rico',
    'UTC',
  ]),
  url_slug: z.string(),
  zip: z.string().nullable(),
});

const zKioskStore = zBaseStore.extend({});

export const zKiosk = z.object({
  checkout_confirmation_message: z.string().nullish(),
  checkout_on_separate_device: z.boolean().nullable(),
  disable_birth_date_at_checkout: z.boolean().nullable(),
  disable_phone_number_at_checkout: z.boolean().nullable(),
  enable_comms_banner: z.boolean().nullable(),
  enabled: z.boolean(),
  id: z.number(),
  inactivity_timeout_ms: z.number().nullable(),
  name: z.string().nullish(),
  refresh_to_landing_timeout_ms: z.number().nullable(),
  remove_jane_branding: z.boolean().nullable(),
  show_checkout_message_field: z.boolean().nullable(),
  show_medical_id_at_checkout: z.boolean().nullable(),
  show_medical_id_expiration_at_checkout: z.boolean().nullable(),
  skip_landing_page: z.boolean().nullable(),
  stores: z.array(zKioskStore),
});
